<template>
  <div
    v-if="showLoading"
    class="m-reset-password"
  >
    <AtomLoadingPrimary :loading-text="$t('mResetPassword.message')"/>
  </div>
  <div
    v-else
    class="a-transition-fade m-card-primary m-reset-password"
  >
    <AtomLogoPrimary class="m-login-academy-name text-align-center font-size-xxlarge"/>
    <form
      autocomplete="off"
      class="a-form-column"
      name="reset-password-form"
      @submit.prevent="createUsuarioResetPasswordUrl"
    >
      <p class="font-weight-bold text-color-academy-primary text-align-center">
        {{ $t('mResetPassword.formInfo') }}
      </p>
      <AtomInputPrimary
        v-model="data.password"
        :inputError="$v.data.password.$error"
        :messageError="messageErrorPassword"
        name="password"
        :placeholder="$t('mResetPassword.inputs.password.placeholder')"
        reference="password"
        type="password"
        @blur="$v.data.password.$touch()"
      />
      <AtomInputPrimary
        v-model="data.confirm_password"
        :inputError="$v.data.confirm_password.$error"
        :messageError="messageErrorConfirmPassword"
        name="confirm_password"
        :placeholder="$t('mResetPassword.inputs.confirm_password.placeholder')"
        reference="confirm_password"
        type="password"
        @blur="$v.data.confirm_password.$touch()"
      />
      <p
        v-if="passwordError"
        class="font-weight-bold text-color-danger text-align-center"
      >
        {{ $t('mResetPassword.alerts.error') }}
      </p>
      <AtomButtonPrimary :button-primary="buttonPrimary"/>
    </form>
  </div>
</template>

<script>
import { minLength, required, sameAs } from 'vuelidate/lib/validators'
export default {
  name: 'MoleculeResetPassword',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mResetPassword.buttonPrimary'),
        behavior: 'login',
        class: 'a-button-academy-primary a-button-login',
        sending: false,
        type: 'submit'
      },

      data: {
        academia_id: '',
        confirm_password: '',
        key: '',
        password: '',
        token: '',
        url_redirect: ''
      },

      passwordError: false,

      showLoading: true
    }
  },

  validations: {
    data: {
      confirm_password: {
        sameAsPassword: sameAs('password'),
        required
      },

      password: {
        valid: function (value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          return (containsUppercase && containsLowercase && containsNumber)
        },
        minLength: minLength(8),
        required
      }
    }
  },

  computed: {
    messageErrorConfirmPassword () {
      return this.$validation.getValidationMessage('mResetPassword', this.$v.data.confirm_password, 'confirm_password')
    },

    messageErrorPassword () {
      return this.$validation.getValidationMessage('mResetPassword', this.$v.data.password, 'password')
    }
  },

  created () {
    this.data.key = this.$route.query.key
    this.data.token = this.$route.query.token
    this.data.url_redirect = this.$route.query.url_redirect
    this.data.academia_id = this.$route.query.academia_id ? this.$route.query.academia_id : ''
    if (this.data.academia_id !== '') {
      this.readAcademia()
    }
  },

  methods: {
    createUsuarioResetPasswordUrl () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.passwordError = false
        this.$services.create('usuario', 'createUsuarioResetPasswordUrl', this.data)
          .then(response => {
            let urlRedirect = response.data
            window.location.replace(urlRedirect)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.passwordError = true
          })
      }
    },

    readAcademia () {
      this.$services.read('academia', 'readAcademia', {}, [this.data.academia_id])
        .then(response => {
          console.log(response.data)
          localStorage.setItem('current_academy', JSON.stringify(response.data))
          this.$store.commit('setAcademyData', response.data)
          this.showLoading = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
